package com.cybersoftsolution.cybersoftsolutionweb.models.ui


import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.Page
import com.cybersoftsolution.cybersoftsolutionweb.models.SimplePost


data class PostsUI(


    var page: Page<SimplePost>? = null,
    var limit: Int? = 4,
    var searchText: String = "",
    var searchCategory: Category? = null,
    var selectPost: Boolean = false,
    var toastMessage: ToastMessage = ToastMessage(),


    )


